<mat-form-field>
  <mat-chip-grid #chipGrid aria-label="Tag selection">
    @for (tag of tags; track tag) {
      <mat-chip-row (removed)="remove(tag)" class="tag-chips">
        {{tag}}
        <button matChipRemove [attr.aria-label]="'remove ' + tag">
          <mat-icon fontSet="fa" fontIcon="fa-times"></mat-icon>
        </button>
      </mat-chip-row>
    }
  </mat-chip-grid>
  <input [placeholder]="'add_tags' | translate" #tagInput [formControl]="tagFilterCtrl"
    [matChipInputFor]="chipGrid" [matAutocomplete]="auto"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    (matChipInputTokenEnd)="add($event)"/>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @for (tag of filteredTags; track tag) {
      <mat-option [value]="tag">{{tag}}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>